export const TOGGLE = 'TOGGLE';

export function toggle(isToggled) {
    return (dispatch) => {
        dispatch({ type: TOGGLE, payload: isToggled});
    };
}